import React from 'react'
import AgentForm from 'components/forms/AgentForm'

const AgentContent = () => {
    return (
        <>
            <div className='flex justify-center'>
                
                <div className='border border-slate-300 shadow-xl p-6 2x:p-8 rounded-sm max-w-xl'>
                    <div className='text-4xl font-bold text-center mb-8'>Join our team</div>
                    <AgentForm />
                </div>

            </div>
        </>
    )
}

export default AgentContent